<div class="main-search">
  <orbit-input
    class="search"
    [placeholder]="'SHARED.CONVERSATION_LIST_SEARCH_BAR.INPUT_PLACEHOLDER' | translate"
    [controller]="searchInputController"
    [large]="true"
    [addonRight]="{ icon: searchIcon }"
    data-testid="conversation-search-input" />
  <button
    type="button"
    class="button-reset filter"
    [class.filter-active]="showFilters()"
    tabindex="0"
    [attr.aria-label]="'Toggle filters'"
    [attr.data-testid]="'btn-toggle-filters'"
    (click)="toggleFilters()"
    (keydown)="onToggleFiltersKeyDown($event)">
    <orbit-fa-icon [iconName]="filterIcon" />
  </button>
</div>
@if (showFilters()) {
  <div class="extended-search" data-testid="conversation-filters">
    <orbit-checkbox
      [name]="'archived'"
      [controller]="showArchivedController"
      [id]="'archived'"
      [label]="'SHARED.CONVERSATION_LIST_SEARCH_BAR.ARCHIVED_FILTER_LABEL' | translate"
      data-testid="checkbox-archived-filter" />
    <div class="conversation-type-header">
      <div class="conversation-type-header-title">
        {{ 'SHARED.CONVERSATION_LIST_SEARCH_BAR.CONVERSATION_TYPE_FILTER_LABEL' | translate }}
      </div>
    </div>
    <div class="conversation-type-list" data-testid="conversation-type-filter-list">
      @for (item of conversationTypeControllers; track item.type.id) {
        <orbit-checkbox
          [name]="item.type.id"
          [controller]="item.controller"
          [id]="item.type.id"
          [label]="item.type.id" />
      }
    </div>
  </div>
}
